import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import ForCompanies from "./pages/ForCompanies";
import ForCandidates from "@/pages/ForCandidates";
import Process from "@/pages/Process";
import CaseStudies from "./pages/CaseStudies";
import PackagingSectors from "./pages/PackagingSectors";
import SectorDetail from "./pages/SectorDetail";
import AboutChris from "./pages/AboutChris";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Layout from "./components/Layout";
import SiteMap from "./pages/SiteMap";
function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Layout>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/for-companies" component={ForCompanies} />
        <Route path="/for-candidates" component={ForCandidates} />
        <Route path="/process" component={Process} />
        <Route path="/case-studies" component={CaseStudies} />
        <Route path="/packaging-sectors" component={PackagingSectors} />
        <Route path="/sectors/:slug" component={SectorDetail} />
        <Route path="/about" component={AboutChris} />
        <Route path="/contact" component={Contact} />
        <Route path="/insights" component={Blog} />
        <Route path="/insights/:slug" component={BlogPost} />
        <Route path="/site-map" component={SiteMap} />
        <Route path="/404" component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
